const CITIES = {
  paris: {
    id: 'paris',
    name: 'Paris',
    title: 'HEARTS IN PARIS',
    totalHearts: 1000,
    subtitle: "qargo inonde Paris d'amour",
    description: "1000 cœurs en LEGO cachés dans Paris pour la Journée Mondiale de l'Art le 15 avril 2026",
    mapCenter: [48.8566, 2.3522],
    mapZoom: 12,
    gridCols: 47,
    gridRows: 43,
    date: '15 avril 2026',
    event: "Journée Mondiale de l'Art",
    heroBg: 'https://static.prod-images.emergentagent.com/jobs/d968817f-a6dd-4b35-a9b8-6f8634275a04/images/4cff68ed62e1357f878f0565aab5d76743ede8b4fdd136d958e4422d6047f1c6.png',
  },
  lille: {
    id: 'lille',
    name: 'Lille',
    title: 'HEARTS IN LILLE',
    totalHearts: 100,
    subtitle: "qargo inonde Lille d'amour",
    description: "100 cœurs en LEGO cachés dans Lille à l'occasion de la venue de qargo pour le salon Solidart Lille le 12 juin 2026",
    mapCenter: [50.6292, 3.0573],
    mapZoom: 13,
    gridCols: 15,
    gridRows: 14,
    date: '12 juin 2026',
    event: 'Salon Solidart Lille',
    heroBg: 'https://static.prod-images.emergentagent.com/jobs/d968817f-a6dd-4b35-a9b8-6f8634275a04/images/42792e145068d833f8770abf9a5d02078e1329c4547d47ec1517e74f3af9894c.png',
  },
};

const detectCity = () => {
  // 1. Env variable (highest priority)
  const envCity = process.env.REACT_APP_CITY;
  if (envCity && CITIES[envCity.toLowerCase()]) {
    return CITIES[envCity.toLowerCase()];
  }

  // 2. Detect from hostname
  const host = window.location.hostname.toLowerCase();
  if (host.includes('lille')) return CITIES.lille;
  if (host.includes('berlin')) return CITIES.berlin;

  // 3. Default to Paris
  return CITIES.paris;
};

export const cityConfig = detectCity();
export default CITIES;
